<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.9287 22.261L20.4939 26.6958C20.2217 26.968 19.7805 26.968 19.5084 26.6958L15.0736 22.261C14.8014 21.9889 14.8014 21.5476 15.0736 21.2755C15.3457 21.0034 15.7869 21.0034 16.0591 21.2755L19.3043 24.5207L19.3043 7.83972C19.3043 7.45485 19.6163 7.14286 20.0011 7.14286C20.386 7.14286 20.698 7.45485 20.698 7.83972L20.698 24.5207L23.9432 21.2755C24.2153 21.0034 24.6566 21.0034 24.9287 21.2755C25.2008 21.5476 25.2008 21.9889 24.9287 22.261Z"
      fill="#3A3A3A"
    />
    <rect
      x="10"
      y="30.7143"
      width="20"
      height="1.42857"
      rx="0.714287"
      fill="#3A3A3A"
    />
  </svg>
</template>
<script>
export default {
  name: 'Download'
}
</script>
